import { LEAVE_TYPES_STRINGS } from "./constants/strings";

import { MainContainer } from "components/MainContainer";

import { VACATION_STRINGS } from "shared/constants/vacationStrings";

import LeaveTypesTable from "./components/LeaveTypesTable";
import { IntegrationComponent } from "components/IntegrationComponent";

const LeaveTypes = () => {
  return (
    <IntegrationComponent
      message={VACATION_STRINGS.INTEGRATION_MESSAGE}
      confirmButtonLabel={VACATION_STRINGS.INTEGRATION_CONFIRM_BUTTON_LABEL}
    >
      <MainContainer
        cancelTittle
        nameScreen={LEAVE_TYPES_STRINGS.TITLE}
        dataTestId="leave-types-main-container"
        alertComponent={null}
      >
        <div className="flex w-full h-full justify-center items-center content-center relative border rounded-md shadow-2xl p-1">
          <LeaveTypesTable />
        </div>
      </MainContainer>
    </IntegrationComponent>
  );
};

export default LeaveTypes;
